import { render, staticRenderFns } from "./CaracteristicasFisicasEstadistica.vue?vue&type=template&id=1e1452a0&scoped=true&lang=pug&"
import script from "./CaracteristicasFisicasEstadistica.vue?vue&type=script&lang=js&"
export * from "./CaracteristicasFisicasEstadistica.vue?vue&type=script&lang=js&"
import style0 from "./CaracteristicasFisicasEstadistica.vue?vue&type=style&index=0&id=1e1452a0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1452a0",
  null
  
)

export default component.exports